import { render } from "./SlipVerificationPanel.vue?vue&type=template&id=30c6a81a"
import script from "./SlipVerificationPanel.vue?vue&type=script&lang=js"
export * from "./SlipVerificationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__